import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const AhrefWrapper = styled.a`
  cursor: pointer;
  display: inline-block;
  font-family: ${props => props.theme.fonts.fontfaceRegular};
  font-size: ${props => props.theme.fonts.sizeButton};
  color: ${props =>
    props.active ? props.theme.colors.black : props.theme.colors.xDarkgray};
  transition: color 0.2s ease-in;
  /* border:1px solid red; */
  padding: 2px 0;
  /* margin-bottom: 2px; */

  &:hover  {
    color: ${props => props.theme.colors.primary};
    /* text-decoration: underline; */
  }
`;

class Ahref extends React.Component {
  render() {
    const { onClick, children, active } = this.props;

    return (
      <AhrefWrapper onClick={onClick} active={active}>
        {children}
      </AhrefWrapper>
    );
  }
}

Ahref.propTypes = {
  onClick: PropTypes.func
};

export default Ahref;



// WEBPACK FOOTER //
// ./src/components/Ahref/Ahref.js